import $ from "jquery";

import * as chromeExtensionInstaller from "chromeExtensionInstaller";
import * as deviceDetect from "deviceDetect";
import * as mustcache from "mustcache";
import * as walkthrough from "walkthrough";

export const showInstaller = () =>
  !walkthrough.hasAchievement("webReader") &&
  !walkthrough.hasAchievement("leavingMessage") &&
  !(
    window.chrome &&
    window.chrome.webstore &&
    $("#readlang-extension-installed").length > 0
  );

export const render = (element, options?) => {
  options = options || {};
  const device = deviceDetect.info();
  const templateData = {
    bookmarkletLink:
      "javascript:var readlangHostname='" +
      window.location.hostname +
      "';document.getElementsByTagName('body')[0].appendChild(document.createElement('script')).setAttribute('src',window.location.protocol+'//" +
      window.location.hostname +
      "/src/translatorBookmarklet.js?bust='+new Date().getTime());",
    device,
    showChrome: !deviceDetect.is("iOS") && !deviceDetect.is("android"),
  };

  if (options.forceShowChromeExtension) {
    templateData.showChrome = true;
  }

  element.html($(mustcache.render("webReaderInstaller", templateData)));
  element.find(".installChromeExtension").click((event) => {
    event.stopPropagation();
    event.preventDefault();
    chromeExtensionInstaller.install();
  });

  element.find(".choiceBox.clickable a").click((event) => {
    event.stopPropagation();
    event.preventDefault();

    alert(
      "To install & use the Readlang Web Reader:\n\n" +
        "1. Drag this into your bookmarks bar.\n" +
        "2. Browse to any other webpage.\n" +
        "3. Click your Readlang Web Reader bookmark."
    );
  });

  if (options.doNotShowAgainElement) {
    options.doNotShowAgainElement.html(
      '<label><input class="doNotShowAgain" type="checkbox"/>Don\'t show this message again, I already have the Web Reader.</label>'
    );

    const doNotShowAgain =
      options.doNotShowAgainElement.find(".doNotShowAgain");
    doNotShowAgain.click(() => {
      const checked = doNotShowAgain.is(":checked");
      const hasAchievement = walkthrough.hasAchievement("leavingMessage");

      if (!hasAchievement && checked) {
        walkthrough.setAchievement("leavingMessage");
      }
      if (hasAchievement && !checked) {
        walkthrough.setAchievement("leavingMessage", false);
      }
    });
  }
};
